import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { WindowEventService } from '@shared/services/window.event.service';

@Directive({
  selector: '[plScrollToInvalidControlOnSubmit]',
})
export class ScrollToInvalidControlOnSubmitDirective {
  constructor(
    private el: ElementRef,
    private formGroupDir: FormGroupDirective,
    private windowEventService: WindowEventService,
  ) {}

  @HostListener('ngSubmit') public onSubmit(): void {
    if (this.formGroupDir.form.invalid) {
      this.scrollToFirstInvalidControl(Array.from(this.el.nativeElement.querySelectorAll('.ng-invalid')));
    }
  }

  private scrollToFirstInvalidControl(invalidControls: HTMLElement[]): void {
    console.log(
      'TONIO ScrollToInvalidControlOnSubmitDirective scrollToFirstInvalidControl invalidControls=',
      invalidControls,
    );
    if (invalidControls.length > 0) {
      const firstInvalidControl: HTMLElement = invalidControls[0];
      if (
        firstInvalidControl.tagName.toLowerCase() !== 'pl-block-via-survey' &&
        firstInvalidControl.tagName.toLowerCase() !== 'pl-block-container' &&
        firstInvalidControl.tagName.toLowerCase() !== 'form'
      ) {
        firstInvalidControl.scrollIntoView({
          behavior: 'smooth',
        });

        this.windowEventService.hasShellComponentHasFinishedScrolling().then(() => {
          firstInvalidControl.focus({ preventScroll: true });
        });
      } else {
        this.scrollToFirstInvalidControl(invalidControls.slice(1));
      }
    }
  }
}
